<template>
  <div  class="product imgTOP-current header-90">
      <div  class="top-img">
        <img class="mobile_hide" src="../assets/images/product-banner.png" alt="">
        <div class="info-box">
          <div class="title-box">
            <h2>{{nameEN}}</h2>
            <h3 v-if="$i18n.locale!='en'">{{name}}</h3>
          </div>
        <!--  <div class="bannerImage">
            <img :src="bannerImage" alt="">
          </div>-->
        </div>
      </div>
    <div class="product-main">
      <div class="product-conten">
        <div class="product-title">
          <router-link to="/home">{{$t("home_0")}}</router-link>
          <em>/</em>
          <span>{{name}}</span>
        </div>
        <div class="nav mobile_hide">
          <h4  :class="{'en-font-28':locale=='EN'}">{{$t('ESG_00')}}</h4>
          <ul>
            <li v-for="(item,index) in typeList" :key="index" @click="tabtitle(item.id, item.name, item.bannerImage)" :class="{ active: paramId == item.id }" class="box">
              <a v-if="(item.name) =='慈善基金會'"><a href="setAim">{{item.name}}</a></a>
              <a v-else :class="{'en-font-18':locale=='EN'}">{{item.name}}</a><em class="nav-line"></em>

            </li>
          </ul>
        </div>
        <div class="type-nav pc_hide" v-if="typeList.length > 0">
          <vue-tab-select v-model="paramId" :list="typeList" :title="'ESG_00'" :keyName="'id'" @valueChanged="changeType"></vue-tab-select>
        </div>
        <div class="product-show">
          <ul>
        <span v-if="this.name =='利害關係人'||this.name =='Stakeholders'||this.name =='利害关系人'">


			<h3>{{$t('ESG_02')}}</h3>
			<div class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">

				<p>{{$t('ESG_001')}}</p>
				<br />
				<h5>{{$t('ESG_002')}}</h5>
        <p>{{$t('ESG_0021')}}</p>
        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
        <img style="max-width:100% ;" src="../assets/images/ESG02E.png" alt="">
      </span>
      <span v-else>
        <img style="max-width:100% ;" src="../assets/images/ESG02.png" alt="">
      </span>
      <p>
        •	聯絡方式：</p><p style="margin-left:2em;padding-right:2em;">
•	電子信箱：IR@8way.com.tw<br>
•	客服電話：0800-898-000<br>
•	電話：(02) 8809-8898

      </p>
        </div>   </div>   </div>   </div>

      </span>

    <span v-if="this.name =='永續發展'||this.name =='Sustainability'||this.name =='永续发展'">


			<h3>{{$t('ESG_03')}}</h3>

      <div class="about-box-01">
        <div class="left">
              <div class="titleBox ">
                <div class="description">
                  <p>{{$t('ESG_003')}}</p><br>
                  <p>{{$t('ESG2021')}}</p>

                   <div >
                    <p>- {{$t('ESG_0030')}}</p>
                    <p>- {{$t('ESG_0031')}}</p>
                    <p>- {{$t('ESG_0032')}}</p>
                    <p>- {{$t('ESG_0033')}}</p>
                    <a href="../../static/files/SustainabilityReport_2021.pdf" target="_blank"><img style="max-width:100% ;" src="../assets/images/ESGS2021.png" alt=""></a>
                    <p>- {{$t('ESG_0034')}}</p>
                    <a href="../../static/files/SustainabilityReport_2021E.pdf" target="_blank"><img style="max-width:100% ;" src="../assets/images/ESGS2021E.png" alt=""></a>
                    <br><br>
                    <p>{{$t('ESG2022')}}</p>
                    <p>- {{$t('ESG_0035')}}</p>
                    <p>- {{$t('ESG_0036')}}</p>
                    <p>- {{$t('ESG_0037')}}</p>
                    <a href="../../static/files/SustainabilityReport_2022.pdf" target="_blank"><img style="max-width:100% ;" src="../assets/images/ESGS2022.png" alt=""></a>
                    <p>- {{$t('ESG_0038')}}</p>
                    <a href="../../static/files/SustainabilityReport_2022E.pdf" target="_blank"><img style="max-width:100% ;" src="../assets/images/ESGS2022E.png" alt=""></a>
                    <br><br>
                    <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">- Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE/TPEx Listed Companies</p>
                    <p v-else>- 111年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</p>
   <p v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'"><a  href="../../static/files/Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE TPEx Listed Companies.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">Fulfillment of ESG and Deviations from the Sustainable Development Best Practices for TWSE/TPEx Listed Companies</a></p>
			<p v-else><a  href="../../static/files/2022年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">111年推動永續發展執行情形及與上市上櫃公司永續發展實務守則差異情形及原因</a></p>
    <br>
    <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'">
    <p>2023</p>
    <p>- In 2023,  obtained  a total of 63 solar energy certificates</p>
    <a  href="https://www.trec.org.tw/en/transaction_history?search=Bafang&year=2023&perPage=10" target="_blank"><img style="max-width:100% ;" src="../assets/images/solar240130EN.jpg" alt=""></a>
    <p>Above information is accepting from National Renewable Energy Certification Center(<a href="https://www.trec.org.tw/en/transaction_history?search=Bafang&year=2023&perPage=10" target="_blank">https://www.trec.org.tw/certification</a>)</p>
    </span>
    <span v-else>
    <p>112年</p>
    <p>- 112年度太陽能發電憑證112年度共取得68張</p>
    <a  href="https://www.trec.org.tw/certification" target="_blank"><img style="max-width:100% ;" src="../assets/images/solar24314TW.png" alt=""></a>
    <p>以上資訊連結至國家再生能源憑證中心(<a href="https://www.trec.org.tw/certification" target="_blank">https://www.trec.org.tw/certification</a>)</p>
    <p>每張憑証為1000度，111年電力排碳係數為0.495公斤CO2e/度</p>
    <p>故可減少0.495公斤CO2e/度*1000度*68張=33,660公斤的CO2排放量</p>

    </span>
    <br>
    <p>- {{$t('ESG_0039')}}<br><a  href="../../static/files/Implementation of Social Welfare in 2023.pdf" target="_blank"><img src="../assets/images/red-pdf.svg" style="width:30px;height:30px">{{$t('ESG_0039')}}</a>
    </p>

    </div>
                  <br>
      <div class="dotted-box">
        <div class="dotted-line">
          <span v-if="locale=='EN'">
                <div class="moreLink">
                  <a href="../../static/files/SustainabilityReport_2021E.pdf" target="_blank">{{$t("company_23_3")}}</a>
                </div>
              </span>
              <span v-else>
                <div class="moreLink">
                  <a href="../../static/files/SustainabilityReport_2021.pdf" target="_blank">{{$t("company_23_3")}}</a>
                </div>
              </span>
        </div>
        <div class="dotted-line">
              <span v-if="locale=='EN'">
                <div class="moreLink">
                  <a href="../../static/files/SustainabilityReport_2022E.pdf" target="_blank">{{$t("company_23_4")}}</a>
                </div>
              </span>
              <span v-else>
                <div class="moreLink">
                  <a href="../../static/files/SustainabilityReport_2022.pdf" target="_blank">{{$t("company_23_4")}}</a>
                </div>
              </span>
              </div>
      </div>
      </div>
      </div>
      </div>
      </div>


    </span>

    <span v-if="this.name =='人權政策'||this.name =='The Human Rights Policy'||this.name =='人权政策'">
      <h3>{{$t('ESG_04')}}</h3>
      <div class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">




        <span v-if = "$i18n.locale=='en'||$i18n.locale=='jpa'||$i18n.locale=='cn'">
          <p>{{$t('ESG_077')}}</p><br>

				<p>{{$t('ESG_078')}}</p><br>

				<p>{{$t('ESG_079')}}</p><br>
        <p>The Company has reserved no less than 1% of the profit earned for employee compensation in its Articles of Association and established the "Regulations for the Implementation of Employee Compensation" to reflect the business performance results on employees.  The company has comprehensive welfare measures and the vacations and other benefits for employees are provided in accordance with the Labor Standards Act and work rules. There is a vocational welfare association to provide diversified welfare care also.  In addition to the relevant laws and regulations, the Company also provides benefits such as marriage subsidy for employees, wedding cash gift for employees' children, incentive payment for employees' childbirth, education subsidy for children, and funeral allowances for employees and their dependents. In accordance with the regulations, an employee welfare committee is established with appropriation of welfare funds to handle employee welfare affairs such as employee travel and health checkup subsidies, birthday gifts, and medical emergency relief loans.</p>
        <br>
        <p>Retirement System and Implementation Status</p>
        <p>The Company has adopted the Regulations Governing Employee Retirements in accordance with the Labor Standards Act, and contributes part of the employees' monthly salaries to the pension fund in a dedicated pension fund account in the Bank of Taiwan. Since the enactment of the Labor Pension Act on July 1, 2005 and adoption of defined contribution pension plan, the Company’s employees may choose the retirement mechanism prescribed in the Labor Standards Act or the pension system of the Labor Pension Act, and their seniority prior to their application to the Labor Pension Act shall be reserved. For workers choosing to be covered by the pension system in accordance with the Labor Pension Act, the Company contributes not less than 6% of the employees’ monthly salaries to the pension fund.</p>
        <br>
        <p>Occupational Safety</p>
        <p>The Company inspects and maintains firefighting and sanitation appliances on a regular basis to prioritizing employee safety and health. The Company also periodically implement employee heath check-ups.</p>
        </span>
        <span v-else>
          <h4>人權政策</h4>
          <p>本公司致力維護員工基本人權，認同並支持「聯合國全球盟約」、「聯合國世界人權宣言」及「國際勞工組織工作基本原則與權利宣言」等國際公認之人權標準，以實際行動體現本公司尊重與保護人權之責任，遵守公司所在地勞動、性別工作平等相關法規規範，禁止強迫、杜絕任何侵犯及違反人權的行為。本公司的人權政策包含對多元的包容性及確保工作機會均等；遵循勞動法令規範，確保僱用政策無差別待遇且不強迫勞動。禁止年齡歧視，保障中高齡者勞動權益，建構友善就業環境；及不非法僱用童工。</p>
          <p>落實職場多元性，不因員工個人性別(含性傾向)、種族、階級、年齡、婚姻、語言、思想、宗教、黨派、籍貫、出生地、容貌、五官及身心障礙等，而有差別待遇或任何形式之歧視。</p>
          <p style="margin-left:1em;padding-right:2em;">● 確保工作機會均等</p>
          <p style="margin-left:2em;padding-right:2em;">截至2023年12月31日，八方雲集台灣地區員工總數為1,273人，其中男性占55.1%，女性占44.9%。除工廠物流同仁因工作性質多為男性之外，其餘各職級之間的性別分布並無顯著差異。所有同仁不論性別、年齡或種族，在內部均享有平等的學習發展機會，有效達到促進性別、就業實質及平等之精神。</p>
          <p style="margin-left:1em;padding-right:2em;">● 多元雇用</p>
          <p style="margin-left:2em;padding-right:2em;">本公司支持並鼓勵在地人才就業，於聘用員工時以在居民為優先考量。同時我們也重視員工的多樣性文化，針對外籍員工提供友善的工作機制及安全健康的工作環境。依據勞動法令規範，我們制定相關管理辦法，積極遵守執行，在員工到職時，詳細說明 《員工工作規則》、《職場不法侵害防治、申訴及調查處理措施》及簽訂聘僱合約書，以保障員工之勞動權益；並依勞動基準法規定終止勞動契約時預告期間。</p>
          <p style="margin-left:1em;padding-right:2em;">● 員工關懷</p>
          <p style="margin-left:2em;padding-right:2em;">•	福利措施：本公司訂有完善的福利措施，休假及其他福利則依循勞基法規定並制定於工作規則，並設有職福會提供多元的福利照護。除依相關法令辦理外，另提供同仁結婚補助、同仁子女結婚禮金、同仁生育獎勵金、子女教養補助、同仁暨眷屬喪葬給付等福利。依規成立職工福利委員會，提撥福利金，辦理如員工旅遊暨健康檢查補助、生日禮金等員工福利事務。</p>
          <p style="margin-left:2em;padding-right:2em;">•	急難救助：「財團法人新北市私立八方雲集社會福利慈善事業基金會」之部分金額指定用途為員工急難救助，在員工遭遇困難時伸出援手協助度過難關。</p>
          <p style="margin-left:1em;padding-right:2em;">● 安全友善的工作環境</p>
          <p style="margin-left:2em;padding-right:2em;">•	職工安全<br>本公司定期檢修消防、衛生器材，重視員工安全與健康，提供員工安全的工作環境與必要的急救措施，消弭工作環境中可能影響員工安全健康之因素，已降低職災風險。此外，重視員工工作與生活的平衡，提供旅遊補助，豐富工作生活平衡的理念。並關懷員工健康，定期辦理健康檢查。</p>
          <p style="margin-left:2em;padding-right:2em;">•	利潤與成果分享<br>本公司已於章程明定保留提撥不低於1%之員工酬勞，制訂「員工酬勞實施辦法」，將經營績效成果反映於員工。</p>
          <p style="margin-left:2em;padding-right:2em;">•	退休制度與其實施情形<br>本公司依據勞動基準法之規定訂定員工退休辦法，每月按薪資總額提撥退休準備金，存入台灣銀行之退休金專戶，勞工退休金條例自民國94年7月1日起施行，並採確定提撥制後，本公司員工得選擇適用「勞動基準法」有關之退休金規定，或適用該條例之退休金制度並保留適用該條例前之工作年資。對適用該條例之員工，本公司每月負擔之員工退休金提撥率，不低於員工每月薪資百分之六。</p>
          <p style="margin-left:2em;padding-right:2em;">•	定期檢視及評估人權相關制度<br>本公司定期檢視人權管理成效，並按評估結果進行觀禮措施之優化，降低相關風險。本公司人權政策同步於公司官網公開揭露，提升員工與利害關係人的人權意識，進而持續改進。</p>
          <br>
          <h4>人權盡職調查</h4>
          <p>八方雲集於2022年制定人權政策，其主要重點包括：多元包容性與確保工作機會均等、順暢的溝通管道、恪遵勞動相關法規、提供安全友善的工作環境、不歧視和定期檢視及評估人權相關制度與作為。一旦風險評估確定結果，將立即制定相應的風險減緩措施，隨後定期審核相關措施的實施效果。同時，透過內部稽核及員工反饋調查等途徑進行檢視，以確保政策的有效實施。</p>
          <p style="margin-left:1em;padding-right:2em;">● 人權盡職調查結果及減緩方案</p>
          <p style="margin-left:2em;padding-right:2em;">本公司未2023年並未發生任何歧視事件，有關針對潛在的人權風險執行之減緩措施如<a href="../../static/files/人權政策-人權盡職調查附件.pdf" target="_blank">附件(PDF)</a></p>

        </span>

			</div></div></div></div>
      </span>
      <span v-if="this.name =='慈善基金會'||this.name =='Foundation'||this.name =='慈善基金会'">

      <div class="about-box-01">
            <div class="left">
              <div class="titleBox ">
                <div class="description">

                  <p><a href="setAim">{{$t('home_01')}}</a></p>

			</div></div></div></div>
      </span>
    </ul>
    </div>
        </div>
      </div>
    </div>

</template>

<script>
  import API from "./config/api";
  import vueTabSelect from "./default/vue-tab-select";
  export default {
    name: 'ESG',
    data () {
      return {
        name:'',
        nameEN:'',
        paramId: '',
        typeList: [],
        ESGListList: [],
        bannerImage: '',
        refname:'top1',
        menuList: [

        ],
        locale:'tw'
      }
    },
    mounted () {
      this.locale=sessionStorage.getItem('lang');
      this.paramId = this.$route.params.ids;
      this.GetTypeList();
      this.locale=sessionStorage.getItem('lang')
      if(this.$route.params.id){
        this.linktop(this.$route.params.id)
      }
      this.$nextTick(()=>{
        this.initSwiper();
      })
    },
    methods:{
      linktop(refid){
        const { top } = $(`#${refid}`).offset();
        $('html , body').animate({scrollTop: top}, 'slow');
        //document.documentElement.scrollTop = this.$refs[refid].offsetTop
        this.refname = refid
      },
      tabtitle(id, name, img, nameEN){
        this.$router.push({ name: 'ESG', params: { ids: id }});
        this.paramId = id;
        this.name = name;
        this.bannerImage = img;
        this.nameEN = nameEN;
        this.GetTypeList();
      },
      changeType(e){
        const [ choose ] = this.typeList.filter((item) => { return this.paramId === item.id });
        this.tabtitle(choose.id, choose.name, choose.bannerImage, choose.nameEN);
      },
      GetTypeList:function(){
        this.$fetch(API.getESGType).then((response) => {
          if(response.code === 200){
            this.typeList = response.data;
            if(this.paramId){
              this.typeList.forEach(item => {
                if(this.paramId === item.id){
                  this.name = item.name;
                  this.nameEN = item.nameEN;
                  this.bannerImage = item.bannerImage;
                }
              })
            }else {
              const [ type = {} ] = this.typeList;
              this.paramId = type.id;
              this.name = type.name;
              this.bannerImage = type.bannerImage;
              this.nameEN = type.nameEN;
            }
            this.GetESGList();
          }
        });
      },
      GetESGList:function(){
        this.$post(API.getESGList,{
          "typeId": this.paramId
        }).then((response) => {
          if(response.code === 200){
            this.ESGList = response.data;
          }
        });
      },
      toDetail: function (id){
        this.$router.push({ name: 'ESTDetails', params: { id: id }});
      }
    },
    watch: {
      $route: {
        handler() {
          this.paramId = this.$route.params.ids;
          this.GetTypeList();
        },
        deep: true,
      }
    },
    components:{
      'vue-tab-select': vueTabSelect
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  ul{
    padding-left:0;
  }
  .product{
    width: 100%;
    height:auto;
    background:#fafafa;
 /*  .top-img{
     width: 100%;
     height: 354px;
     position: relative;
     background:#fafafa url("../assets/images/product-banner.png") no-repeat top;
     background-size: 100% 100%;;
     .bg-img{
       position: absolute;
       width: 100%;
     }
     img{
      !* width: 100%;
       height: 100%;
       background-size: cover;*!
     }
     .info-box{
       width: 100%;
       max-width: 1392px;
       padding: 0 20px 0 9.339%;
       margin: 0 auto;
       &:after{
         content: "";
         display: block;
         clear: both;
       }
       .title-box{
         max-width: 54%;
         float: left;
         padding-top: 60px;
         text-align: right;
         h2{
           color: #FFFFFF;
           font-size: 68px;
           font-style: italic;
           font-weight: 900;
           letter-spacing: 0;
           line-height: 75px;
           margin-bottom: 15px;
         }
         h3{
           color: #FFFFFF;
           font-size: 36px;
           letter-spacing: 1px;
           line-height: 42px;
           margin: 0;
         }
       }
       .bannerImage{
         float: right;
         width: 46%;
         padding-top: 25px;
         img{
           width: 100%;
         }
       }
     }
   }*/


  .bannerImage{
    width: 30%;
 /*   padding-top: 25px;
    float: right;*/
    position: absolute;
    right:15%;
    bottom:-5px;
       img{
         width: 100%;
       }
  }

  .product-main{
    width: 100%;
    height: 100%;
    background: #f9f9f9 url("../assets/images/product-contenBg.png") no-repeat center 100px;
    background-size: 100% auto;
    overflow: hidden;
    padding-top: 36px;
    padding-bottom: 140px;
  }
   .product-conten{
     max-width:1390px;
     padding: 0 20px;
     margin: 0 auto;
    .product-title{
      padding-bottom:40px;
      font-size: 14px;
      letter-spacing: 1.5px;
      text-align: left;
       a{
         color: #000;
         text-decoration: underline;
       }
      em{
        padding: 0 4px;
      }
      span,em{
        color: #9A928D;
      }
    }
    .nav{
      height: auto;
      width: 350px;
      border-radius: 20px;
      background-color: #FFFFFF;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
      padding:55px 48px 55px 44px;
      position: relative;
      float: left;
      h4,ul{
       width: 100%;
      }
      h4{
        font-size: 28px;
        font-weight: 500;
        letter-spacing: 2.1px;
        padding-bottom:8px;
      &.en-font-28{
         letter-spacing: 0px;
         font-family: 'Roboto Medium';
       }
      }
      a{
        color: #000;
        font-size: 18px;
        letter-spacing: 1.35px;
        cursor: pointer;
        display: block;
        &.active{
            color:red
          }
        &.en-font-18{
           letter-spacing: 0px;

         }
      }
     ul{
       li{
         padding: 25px 0;
         border-bottom:1px solid #e2e2e2;
         position: relative;
       }
     }
    .active{
      color: #CF0902;
      font-weight: 500;
      a{
        color: #CF0902;
      }
      .nav-line{
        height: 5px;
        width: 46px;
        display: inline-block;
        background-color: #CF0902;
        position: absolute;
        right: -63px;
        top: 36px;
      }
    }
      li:hover{
        color: #CF0902;
        font-weight: 500;
        a{
          color: #CF0902;
        }
      }
    }

   }

    .product-show {
      width: calc(100% - 350px);
      height: auto;
      float: left;
      padding-left: 124px;

      .left{
      width: 100%;
      display: inline-block;
      box-sizing: border-box;
      padding-top: 10px;
      .description{
        margin-top: 27px;
        height: auto;
        max-width: 718px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding: 38px 15px 15px 15px;
        margin-left: 22px;
        p{
          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
      ul {
        padding-left: 0;

        li {
          width: calc( (100% - 180px ) / 3);
          float: left;
          cursor: pointer;
          margin: 0 36px 50px;
          .img-box{
            position: relative;
          }
          .big-img-box {
            width: 100%;
            border-radius: 50%;
            border: 8px solid #fff;
            overflow: hidden;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img {
              width: 100%;
              height: 100%;
              background-size: 100%;
            }
          }
          .small-img-box{
            width: 66px;
            height: 66px;
            border: solid 3px #fff;
            border-radius: 50%;
            overflow: hidden;
            background: #fff;
            position: absolute;
            right: 0;
            bottom: 19px;
            box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
            img{
              width: 100%;
            }
          }

          p {
            text-align: center;
            padding-top: 10px;
            font-size: 18px;
            letter-spacing: 0.9px;
            line-height: 42px;
            color: #000;
          }
          &:nth-child(3n + 1){
            clear: both;
          }
          &:nth-child(3n){
            margin-right: 0;
          }
        }
      }
    }
  }
  @media (max-width:1080px){
    .type-nav{
      margin-top: 10px;
    }
    .product{
      .product-main{
        background-image: url("../assets/images/product-bg-mobile.png");
      }
      .top-img{
        height: 187px;
        background-image: url("../assets/images/product-banner-mobile.png");
        background-size: 100% auto;
        background-color: #f9f9f9;
        background-repeat: no-repeat;
        .info-box{
          position: relative;
          height: 100%;
          .title-box{
            padding-top: 20px;
            position: static;
            float: left;
            h2{
              font-size: 24px;
              letter-spacing: 0;
              line-height: 28px;
              margin-bottom: 9px;

            }
            h3{
              font-size: 20px;
              letter-spacing: 0.56px;
              line-height: 28px;
            }
          }
          .bannerImage{
            width: auto;
            height: 66%;
            position: absolute;
            bottom: 12px;
            right: 20px;
            text-align: right;
            img{
              width: auto;
              height: 100%;
            }
          }
        }
      }
       .product-main{
         padding:0 20px;
         padding-top: 20px;

       }
       .product-conten{
         padding: 0;
         .product-title{
           padding-bottom: 20px;
         }
       }

     .product-show{
       width: 100%;
       padding: 30px 0;
       ul{
         padding: 0 5px;
         li{
           width: 50%;
           padding: 0 25px;
           margin: 0 0 25px 0;
           .img-box{
             margin-bottom: 2px;
           }
           .big-img-box{
             border-width: 5px;
             width: 100%;
             margin: 0;
           }
           p{
             font-size: 15px;
             letter-spacing: 0.5px;
             line-height: 28px;
             padding-top: 0;
           }
           &:nth-child(3n+1) {
             clear: inherit;
           }
           &:nth-child(2n+1) {
             clear: both;
           }
         }
       }
     }
    }
  }
  .table-bordered{

width:100%;
color: #2A1C15;
font-size: 18px;
line-height: 32px;
text-align: justify;
letter-spacing: 1px;


}
    .about-box-01{
    width: 100%;
    height: auto;
    overflow: hidden;
    .titleBox {
      h2{
        margin-bottom: 13px;
      }
    }
    .left{
      width: 51.3888%;
      display: inline-block;
      box-sizing: border-box;
      padding-top: 126px;
      .description{
        margin-top: 27px;
        height: auto;
        max-width: 718px;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
        padding: 58px 75px 63px 78px;
        margin-left: 22px;
        p{
          width:100%;
          color: #2A1C15;
          font-size: 18px;
          line-height: 32px;
          text-align: justify;
          letter-spacing: 1px;
        }
      }
    }
    .right{
      width: 43.6805%;
      display: inline-block;
      vertical-align: top;
      padding: 57px 32px 0 38px;
      &.pc_hide{
        display: none;
      }
      .img{
        max-width: 560px;
        height: auto;
        img{
          width: 100%;
          height: 100%;
          background-size: 100%;
        }
      }
    }
  }




  .dotted-box{
       .dotted-line{
        border-bottom: 1px dashed #979797;
        padding-top:6px;
        padding-bottom:6px;
         span{
           color: #000000;
           font-size: 18px;
           font-family: "Roboto Medium Italic";
           line-height: 21px;
           letter-spacing: 0.9px;
         }
         }
         }

</style>



// WEBPACK FOOTER //
// src/components/ESG.vue